import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='SMS'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'SMS',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/sms',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
